/* ++++++++++ --------------- IMPORT --------------- ++++++++++ */
import { disable } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : IMAGE UPLOAD : STYLES --------------- ++++++++++ */
export default theme =>({
	imageupload: {
        '& .cropperSlider': {
            backgroundColor: theme.color.light.light.swatch
        },
        '&.uploadingimage-true': {
            '& .cropperSlider': {
                '& .inner': {
                    extend: disable
                }
            }
        }
	}// styles come from parent containers that house this
});
